import { FC } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { useForm } from '@/forms/hooks/use-form';
import { OrganisationFieldValues } from '@/forms/schemas/organisation/field-values';
import { organisationFormSchema } from '@/forms/schemas/organisation/schema';
import { mergeSchemaAndValues } from '@/forms/utils/merge-schema-and-values';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';
import { Organisation } from '@/types/organisation';

export type EditOrganisationFormProps = {
  organisation: Organisation;
  onCancel: () => void;
  onDisable: () => void;
  onSubmit: (values: OrganisationFieldValues) => void;
};

export const EditOrganisationForm: FC<EditOrganisationFormProps> = ({
  organisation,
  onCancel,
  onDisable,
  onSubmit,
}) => {
  const { fieldItems, handleSubmit } = useForm({
    schema: mergeSchemaAndValues(organisationFormSchema, organisation),
    onSubmit,
  });

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <Button key="disable" onClick={onDisable} variant="secondary-warning">
          {strings.organisations.drawer_edit_form.disable}
        </Button>,
        <div className="flex-grow" key="flex"></div>,
        <Button key="cancel" onClick={onCancel} variant="secondary">
          {strings.organisations.drawer_edit_form.cancel}
        </Button>,
        <SubmitButton
          key="submit"
          text={strings.organisations.drawer_edit_form.submit}
        />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
